import { render } from "./CloseHeader.vue?vue&type=template&id=125972e4&scoped=true&ts=true"
import script from "./CloseHeader.vue?vue&type=script&lang=ts"
export * from "./CloseHeader.vue?vue&type=script&lang=ts"

import "./CloseHeader.vue?vue&type=style&index=0&id=125972e4&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125972e4"]])

export default __exports__